module.exports = __webpack_public_path__ + "static/media/ZipPlusTruck.9de34843.png";